module.exports = __webpack_public_path__ + "82117dd5990427f34d75d523d5e22752.pdf";